import React from 'react';
import { createSwitchNavigator } from '@react-navigation/core';
import { createBrowserApp } from '@react-navigation/web';
import {
    DeepLinkQueryParamsToStateHOC,
    HomeMyWorkoutResultsScreen,
} from 'fitbeat.react-native-components';

import HomeNavigator from './HomeNavigator';
import AuthNavigator from './AuthNavigator';
import { AppLayout } from '../Components/Layouts/AppLayout';
import { AuthLoadingContainer } from '../Components/AuthLoadingContainer';
import { HomeCarouselAuthLayout } from '../Components/Layouts/HomeCarouselAuthLayout';
import { InfluencerContainer } from '../Components/InfluencerPage/InfluencerContainer';

const MyWorkoutResultsContainer = (props) => {
    return (
      <HomeCarouselAuthLayout hasAccessToAStudioGym={false} {...props} hideScroll isDarkTheme>
          <HomeMyWorkoutResultsScreen {...props} />
      </HomeCarouselAuthLayout>
    )
}

const AppNavigator = createBrowserApp(
  createSwitchNavigator(
    {
      AuthLoading: AuthLoadingContainer,
      AuthNavigator: {
        screen: AuthNavigator,
        path: 'auth',
      },
      HomeNavigator: {
        screen: HomeNavigator,
      },
      MyWorkoutResults: {
        screen: MyWorkoutResultsContainer,
        path: 'my-workout-results',
      },
      Influencer: {
        screen: InfluencerContainer,
        path: 'influencer',
        navigationOptions: () => ({
          header: null,
        }),
      },
    },
    {
      initialRouteName: 'AuthLoading',
    }
  )
);

const AppContainer = (props) => {
    return (
        <AppLayout {...props}>
            <AppNavigator {...props} />
        </AppLayout>
    )
}


export default DeepLinkQueryParamsToStateHOC(AppContainer);
